import Head from 'next/head'
import { useEffect, useState } from 'react'

import ForgotPasswordForm from '@/components/forms/auth/ForgotPasswordForm'
import ConfirmForgotPassword from '@/components/forms/auth/ConfirmForgotPassword'
import { useRouter } from 'next/router'
import { getSession, useSession } from 'next-auth/react'
import { GetServerSidePropsContext } from 'next'
import { UserRoleEnum } from '@/types/cognito'

const ForgotPassword = () => {
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [sharedValues, setSharedValues] = useState({
    email: '',
  })
  const router = useRouter()
  const { data: session } = useSession()

  useEffect(() => {
    if (session) router.push('/portal/account')
  }, [session])

  return (
    <div className="flex flex-col w-full h-[784px] pt-20 px-4">
      <Head>
        <title>Forgot Password? | North Park Transportation</title>
      </Head>

      {!showConfirmation ? (
        <ForgotPasswordForm
          setShowConfirmation={setShowConfirmation}
          setSharedValues={setSharedValues}
        />
      ) : (
        <ConfirmForgotPassword sharedValues={sharedValues} />
      )}
    </div>
  )
}

export default ForgotPassword

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req } = context
  const session = await getSession({ req })

  if (session && session?.user?.role === UserRoleEnum.NOPK_ADMIN) {
    return {
      redirect: {
        destination: '/portal/admin',
        permanent: false,
      },
    }
  }

  if (session && session?.user?.userID) {
    return {
      redirect: {
        destination: '/portal/account',
        permanent: false,
      },
    }
  }

  return {
    props: {},
  }
}
